import { DbJobHighLevelDefinitionInfos } from "./db-job-high-level-definition-infos";
import { DbJobRuleInputFilterInfos } from "./db-job-rule-input-filter-infos";
import { DbJobRulePostActionInfos } from "./db-job-rule-post-action-infos";
import { DbMongoBaseInfos } from "./db-mongo-base-infos";
import { FileCategory } from "./file-category";
import { JobRuleTag } from "./job-rule-tag";

export class DbJobRuleInfos extends DbMongoBaseInfos {
  enabled: boolean | null = null;
  executeAllDefinitions: boolean = false;
  platformIds: number[] | null = null;
  name: string | null = null;
  description: string | null = null;
  inputFileCategory: FileCategory | null = null;
  filter: DbJobRuleInputFilterInfos | null = null;
  groupIds: number[] | null = null;
  jobsDefinitions: DbJobHighLevelDefinitionInfos[] | null = null;
  postActions: DbJobRulePostActionInfos[] | null = null;
  tag: JobRuleTag | null = null;

  constructor(init?: Partial<DbJobRuleInfos>) {
    super();
    Object.assign(this, init);
  }
}
